import { KontentMedia } from '../../../../types/KontentProps';

export interface KontentImageData {
    image: { url: string; width: number; height: number } | null;
    alt: string;
}

export function getImageData(imageField: KontentMedia): KontentImageData {
    const asset = imageField?.value[0]?.elements?.file?.value[0];
    return {
        image: asset?.url
            ? {
                  url: asset.url,
                  width: asset.width || 0,
                  height: asset.height || 0,
              }
            : null,
        alt: asset?.description || asset?.name || '',
    };
}

export function getImageUrl(imageField: KontentMedia): string | null {
    return imageField?.value[0]?.elements?.file?.value[0]?.url || null;
}
